import { Component, OnInit } from '@angular/core';
import { GestoresService } from 'src/app/services/gestores.service';
import { NgxSpinnerService } from 'ngx-spinner'
import { $ } from 'jquery'
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { StatusEleicao } from 'src/app/models/enums/status-eleicao-enum';
import { ModalComprovanteZeresimaComponent } from 'src/app/pages/gestor/modals/comprovante-zeresima/modal-comprovante-zeresima.component';
import { ModalRelatoriosCandidaturasComponent } from 'src/app/pages/gestor/modals/relatorios-candidaturas/modal-relatorios-candidaturas.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Logins } from 'src/app/models/logins.model';
import { Utils } from 'src/app/utils/utils';
import { CandidaturaService } from 'src/app/services/candidatura.service';
import { PreCandidatosService } from 'src/app/services/precandidatos.service';
import { RelatorioPreCandidato } from 'src/app/models/relatorioPreCandidato.model';
import sortBy from 'sort-by';

declare var window: any;

@Component({
  selector: 'app-gestor',
  templateUrl: './gestor.component.html',
  styleUrls: ['./gestor.component.css']
})
export class GestorComponent implements OnInit {

  zeresimaData: any;
  listaDeResultados: any;
  listaDeEleicoes: any;
  respostaCriacaoEleicao: any;
  token: string;
  infoGestor: any;
  eleicaoModal: any = {}; //eleição clicada para abrir no modal
  dataHoraAtual: Date;
  dataInicio: Date;
  semEleicoes: any;
  Logins: Logins;
  permissaoGestor: any;
  idGestor: any;
  candidatura:any;
  relatoriosCandidaturasData: any;
  idEleicaoParaApurar: any;
  formModalApurar: any;

  constructor(
    protected router: Router,
    public route: ActivatedRoute,
    protected gestores: GestoresService,
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
    public spinner: NgxSpinnerService,
    protected messageService: MessageService,
    protected candidaturaService: CandidaturaService,
    protected preCandidatoService: PreCandidatosService,
    public utils: Utils
  ) { }

  ngOnInit() {
    this.spinner.show()
    this.dataHoraAtual = new Date;
    this.token = sessionStorage.getItem('token');
    this.infoGestor = JSON.parse(sessionStorage.getItem('infoGestor'));
    this.permissaoGestor = this.infoGestor.Role == "ROLE_GESTOR";
    this.idGestor = this.permissaoGestor ? this.infoGestor.id : this.infoGestor.idGestor;
    this.buscarEleicoesPorId(this.idGestor);
    this.formModalApurar = new window.bootstrap.Modal(
      document.getElementById('modalConfirmarApuracao')
    );
  }

  goToCountdown(dataHoraInicio){
    sessionStorage.setItem("dataHoraInicio",dataHoraInicio);
    this.router.navigate(['countdown'], { relativeTo: this.route });
  }

  buscarEleicoesPorId(id) {
    this.gestores.buscarEleicaoPorIdGestor(this.token, id).then((data: any) => {
      this.listaDeEleicoes = data;
      let listLength = this.listaDeEleicoes.length

      //Omissão de eleições antigas para apresentação
      for(let i = 0; i < listLength; i++) {
        if(new Date(this.listaDeEleicoes[i].dataHoraInicio) < new Date("2023-03-22T10:00:21.817Z")){
          this.listaDeEleicoes.splice(i, 1);
          listLength--;
          i--;
        }
      }

      if(data == null || data.length == 0){
        this.semEleicoes = true;
      }else {
        this.semEleicoes = false;
      }
      this.spinner.hide();

    });
  }

  private abrirModalComprovante() {
    const initialState = {
      title: 'Comprovante de computação da Zerésima.',
      header: 'ATENÇÃO! Salve o comprovante em um lugar seguro, pois ele é gerado somente uma vez.',
      zeresimaData: JSON.parse(localStorage.getItem("zeresimaData")),
      // onSuccess: this.getTesteConsole.bind(this)
    };
    this.bsModalRef = this.modalService.show(ModalComprovanteZeresimaComponent, { initialState, class: 'modal-lg' });
  }

  inserirZeresima(idEleicao) {
    this.gestores.inserirZeresima(this.token, idEleicao).then(data => {
      this.zeresimaData = JSON.stringify(data);
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Zerésima inserida!' });
      location.reload();
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
    });
  }
  
  buscarLogsAcesso(idEleicao, token) {
    this.gestores.getAllLogsAcessoByIdEleicao(idEleicao, this.token).then(data =>  {
      this.Logins = data;
        this.utils.exportRelatoriosParaExcel(this.Logins)
      console.log(this.Logins)
    }).catch(err => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Ocorreu um erro na tentativa de download do relatório.' });
    });
  }

  buscarZeresima(idEleicao){
    this.gestores.buscarZereseima(this.token, idEleicao).then(data => {
      this.zeresimaData = JSON.stringify(data);
      localStorage.setItem("zeresimaData", this.zeresimaData);
      this.abrirModalComprovante();
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Ocorreu um erro ao buscar a Zerésima.' });
    })
  }

  iniciarEleicao(id,dataInicio) {
    this.dataInicio = new Date(dataInicio);
    if(this.dataHoraAtual < this.dataInicio){
      this.goToCountdown(this.dataInicio);
    }else{
      let status = StatusEleicao.EM_ANDAMENTO
      this.gestores.alterarStatusEleicao(this.token, id, status).then(data => {
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Eleição iniciada!' });
        window.location.reload();
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Ocorreu um erro ao iniciar a eleição.' });
        location.reload()
      });
    }
  }

  iniciarCandidatura(id) {
    let status = StatusEleicao.EM_CANDIDATURA

    this.candidaturaService.listarPorIdEleicao(id, this.token).then(data => {
      this.candidatura = data;
      this.dataInicio = new Date(this.candidatura.dataHoraInicioCandidaturas);
      if(this.dataHoraAtual > this.dataInicio){
        this.gestores.alterarStatusEleicao(this.token, id, status).then(data => {
          this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Período de candidaturas iniciado com sucesso!' });
          window.location.reload();
        }, error => {
          this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Ocorreu um erro ao iniciar o período de candidaturas.' });
          location.reload()
        });
      }else{
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Não é possível iniciar o período de candidaturas antes do horário parametrizado." });
      }  
    }).catch(error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Não foi possível iniciar o período de candidaturas." });
    });
  }

  finalizarCandidatura(id) {
    let status = StatusEleicao.AGUARDANDO_APROCACOES
    this.candidaturaService.listarPorIdEleicao(id, this.token).then(data => {
      this.candidatura = data;
      this.dataInicio = new Date(this.candidatura.dataHoraFimCandidaturas);
      if(this.dataHoraAtual > this.dataInicio){
        this.gestores.alterarStatusEleicao(this.token, id, status).then(data => {
          this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Período de candidaturas finalizado com sucesso!' });
          window.location.reload();
        }, error => {
          this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Ocorreu um erro ao finalizar o período de candidaturas.' });
          location.reload()
        });
      }else{
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Não é possível finalizar o período de candidaturas antes do horário parametrizado." });
      }  
    }).catch(error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Não foi possível finalizar o período de candidaturas." });
    });
  }

  iniciarAprovacoes(id) {
    let status = StatusEleicao.EM_APROVACOES

    this.candidaturaService.listarPorIdEleicao(id, this.token).then(data => {
      this.candidatura = data;
      this.dataInicio = new Date(this.candidatura.dataHoraInicioAprovacao);
      if(this.dataHoraAtual > this.dataInicio){
        this.gestores.alterarStatusEleicao(this.token, id, status).then(data => {
          this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Período de aprovação de candidaturas iniciado com sucesso!' });
          window.location.reload();
        }, error => {
          this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Ocorreu um erro ao iniciar o período de aprovação de candidaturas.' });
          location.reload()
        });
      }else{
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Não é possível iniciar o período de aprovação de candidaturas antes do horário parametrizado." });
      }  
    }).catch(error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Não foi possível iniciar o período de aprovação de candidaturas." });
    });
  }
  

  apurarEleicao(id) {
    this.idEleicaoParaApurar = id;
    this.formModalApurar.show();
  }

  confirmarApuracao() {
    this.formModalApurar.hide();
    this.gestores.apurarResultadoDaEleicao(this.token, this.idEleicaoParaApurar).then(data => {
      this.respostaCriacaoEleicao = data;
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Eleição apurada!' });
      this.buscarEleicoesPorId(this.infoGestor.id);
    }).catch( error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: error, detail: 'Ocorreu um erro ao realizar a apuração.' });
    });
  }

  cancelarApuracao() {
    this.idEleicaoParaApurar = null;
    this.formModalApurar.hide();
  }

  

  async abrirResultado(idEleicao, eleicao) {
    sessionStorage.setItem("idEleicao", idEleicao)

    sessionStorage.setItem("logoeleicao", JSON.stringify(eleicao.logo));

    this.router.navigate(['resultado-eleicao'], { relativeTo: this.route });
  }

  async abrirResultadoParcial(idEleicao, eleicao) {
    sessionStorage.setItem("idEleicao", idEleicao)

    sessionStorage.setItem("logoeleicao", JSON.stringify(eleicao.logo));

    this.router.navigate(['resultado-parcial-eleicao'], { relativeTo: this.route });
  }

  async cadastrarEleicao() {
    this.router.navigate(['cadastro-eleicao'], { relativeTo: this.route });
  }

  parametrizacoesEleicao(eleicao){
    this.spinner.show();
    sessionStorage.setItem("eleicaoClicadaParametrizacao", JSON.stringify(eleicao));
    this.router.navigate(['../configuracoes'], {relativeTo: this.route});
  }

  parametrizacoesEmail(eleicao){
    this.spinner.show();
    sessionStorage.setItem("eleicaoClicadaParametrizacao", JSON.stringify(eleicao));
    this.router.navigate(['../config-email'], {relativeTo: this.route});
  }

  abrirVisualizacaoEleicao(eleicao){
    this.spinner.show();
    sessionStorage.setItem("eleicaoClicadaParametrizacao", JSON.stringify(eleicao));
    this.router.navigate(['../preview'], {relativeTo: this.route});
  }
  
  async abrirRelatorioVotos(idEleicao, eleicao) {
    sessionStorage.setItem("idEleicao", idEleicao)

    sessionStorage.setItem("logoeleicao", JSON.stringify(eleicao.logo));

    console.log("Aqui!")

    this.router.navigate(['../relatorio-votos'], { relativeTo: this.route });
  }

  async abrirRelatorioEmails(idEleicao, eleicao) {
    sessionStorage.setItem("idEleicao", idEleicao)

    sessionStorage.setItem("logoeleicao", JSON.stringify(eleicao.logo));

    console.log("Aqui!")

    this.router.navigate(['../relatorio-email'], { relativeTo: this.route });

  }

  abrirModalRelatoriosCandidaturas(idEleicao: number) {
    this.relatoriosCandidaturasData = {
      token: this.token,
      idEleicao: idEleicao,
    }
    const initialState = {
      title: 'Relatórios de pré-candidaturas.',
      header: 'Selecione para fazer o dowload do relatório analítico ou do relatório sintético.',
      relatoriosCandidaturasData: this.relatoriosCandidaturasData,
      // onSuccess: this.getTesteConsole.bind(this)
    };
    this.bsModalRef = this.modalService.show(ModalRelatoriosCandidaturasComponent, { initialState, class: 'modal-lg' });
  }

  gerarCandidatos(idEleicao: number){
    this.gestores.gerarCandidatos(this.token, idEleicao, this.idGestor).then(data => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Candidatos gerados com sucesso!' });
      window.location.reload();
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Ocorreu um erro ao gerar os candidatos.' });
      location.reload()
    });
  }

}
